import {
  popup_opening,
  popup_closed,
  popup_pending,
} from '@/components/PublicPopup/config'
import { isJsonString } from '@/utils/tool'

/**
 */

// 消息管理
export const Message = {
  post(item) {
    if (process.client) {
      window.postMessage(JSON.stringify({ type: 'openNext', data: item }), '*')
    }
  },
  messageHandle() {
    const [callback, event] = Array.from(arguments) || [() => {}, {}]
    if (isJsonString(event.data)) {
      const json = JSON.parse(event.data) || {}
      const { type, data } = json
      if (type === 'openNext') {
        callback && typeof callback === 'function' && callback(data)
      }
    }
  },
  receive(callback) {
    if (process.client) {
      window.addEventListener(
        'message',
        this.messageHandle.bind(this, callback)
      )
    }
  },
  destroy() {
    if (process.client) {
      window.removeEventListener('message', this.messageHandle)
    }
  },
}

// 优先级队列
class PriorityQueue {
  constructor() {
    this.dataSource = []
    this.currentIndex = -1
    this.nextIndex = -1
  }

  enqueue(item = {}) {
    if (!process.client) {
      return
    }
    item.status = popup_pending
    // 没有priority属性，则默认赋值9999（数值越大优先级越小）
    if (!item.priority) {
      item.priority = 9999
    }
    if (item.priority < 1) {
      window.console.error('优先级最小为1')
      return
    }
    // eslint-disable-next-line no-prototype-builtins
    if (!item.hasOwnProperty('id')) {
      window.console.error('数据中必须要有id属性')
      return
    }
    const sameNodes = this.dataSource.filter((node) => node.id === item.id)

    if (sameNodes && sameNodes.length > 0) {
      window.console.error('id不能相同')
      return
    }
    const samePriorityNodes = this.dataSource.filter(
      (node) => node.priority === item.priority
    )
    if (samePriorityNodes && samePriorityNodes.length > 0) {
      window.console.error('priority优先级不能相同')
      return
    }
    if (this.isEmpty()) {
      this.dataSource.push(item)
      // 第一个入队的不需要等待其他的是否入队则立即去执行，其余的则会进行排队，按照优先级进行排序
      // Message.post(item)
    } else {
      let added = false
      for (let i = 0; i < this.dataSource.length; i++) {
        const list = this.dataSource[i]
        if (item.priority < list.priority) {
          this.dataSource.splice(i, 0, item)
          added = true
          break
        }
      }
      // 如果元素没有插入到队列中，则默认加到队列的尾部
      if (!added) this.dataSource.push(item)
    }
    this.autoPush()
  }
  // 移除元素
  dequeue(id) {
    if (!this.isEmpty()) {
      if (id) {
        const target = this.getNode(id) || {}
        const { index } = target
        this.dataSource.splice(index, 1)
      } else {
        this.dataSource.shift()
      }
    }
  }

  getNode(id) {
    let res = {}
    if (!this.isEmpty()) {
      this.dataSource.forEach((data, index) => {
        if (data.id === id) {
          res = {
            data,
            index,
          }
        }
      })
    }
    return res
  }

  isEmpty() {
    return this.dataSource.length === 0
  }

  getLength() {
    return this.dataSource.length
  }

  clear() {
    // 需要把还没有弹的保留
    const popupPending =
      this.dataSource.filter((item) => item.status === popup_pending) || []

    this.dataSource = popupPending
    this.currentIndex = -1
    this.nextIndex = -1
    Message.destroy()
  }

  front() {
    return this.dataSource[0]
  }

  back() {
    return this.dataSource[this.getLength() - 1]
  }

  close(id) {
    this.dataSource.forEach((item, index) => {
      if (item.id === id) {
        this.dataSource[index].status = popup_closed
        // this.dequeue(id)
        // if (this.currentIndex + 1 < this.getLength()) {
        //   this.nextIndex = this.currentIndex + 1
        // } else {
        //   this.nextIndex = -1
        // }
        this.currentIndex = -1
        const nextTarget = this.getNextOpenTarget() || {}
        if (nextTarget.status === popup_pending) {
          Message.post(nextTarget)
        }
      }
    })
  }

  open(id) {
    this.dataSource.forEach((item, index) => {
      if (item.id === id) {
        this.dataSource[index].status = popup_opening
        this.currentIndex = index
      }
    })
  }

  getOpeningTarget() {
    if (this.currentIndex === -1) {
      return null
    }
    return this.dataSource[this.currentIndex]
  }

  getNextOpenTarget() {
    let target = null
    for (let index = 0; index < this.dataSource.length; index++) {
      if (this.dataSource[index].status === popup_pending) {
        target = this.dataSource[index]
        this.nextIndex = index
        break
      }
    }
    return target
  }
  // 当之前的弹框都已经关闭后，突然又有入队时要主动触发推送
  autoPush() {
    if (!process.client) {
      return
    }
    const timeid = setInterval(() => {
      const pendingPopupList =
        this.dataSource.filter((item) => item.status === popup_pending) || []

      const nextPopup = pendingPopupList.sort(
        (v1, v2) => v1.priority - v2.priority
      )[0]

      const openingPopup =
        this.dataSource.filter((item) => item.status === popup_opening) || []

      if (openingPopup.length === 0 && nextPopup) {
        Message.post(nextPopup)
      }

      if (!nextPopup) {
        clearInterval(timeid)
      }
    }, 1000)
  }
}

export const PQ = new PriorityQueue()

if (process.client) {
  window.PQ = PQ
}
